import Sentry from '../Sentry';

/**
 * `?hookdeck_from=ingest` is set by the edge middleware when it redirects a browser
 * navigation off the ingestion path (`/e/{id}`). Reading it is one-shot: the param is
 * stripped from the URL so the notice doesn't reappear on reload, or on a link the visitor
 * copies from the address bar and shares.
 *
 * Namespaced deliberately — the redirect carries the caller's own query string across, and
 * a bare `from` would collide with (and overwrite) tracking the caller already had. Keep
 * this in sync with `INGEST_REDIRECT_PARAM` in src/edge/ingest-navigation.ts; the edge
 * module can't be imported here because it is bundled for the Vercel edge runtime.
 */
export const INGEST_NAVIGATION_PARAM = 'hookdeck_from';
const INGEST_NAVIGATION_VALUE = 'ingest';

export const consumeIngestNavigationFlag = (): boolean => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get(INGEST_NAVIGATION_PARAM) !== INGEST_NAVIGATION_VALUE) {
      return false;
    }

    params.delete(INGEST_NAVIGATION_PARAM);
    const query = params.toString();
    window.history.replaceState(
      {},
      document.title,
      `${window.location.pathname}${query ? `?${query}` : ''}`,
    );
    return true;
  } catch (e) {
    Sentry.captureException(e);
    return false;
  }
};
